module.exports = __webpack_public_path__ + "static/media/home_record.c071f9826c4d08b8d4abd5981ca12eac.svg";